export default {
  APP: {
    AUTHORIZATION: {
      BAD_CREDENTIALS: "Podana nazwa użytkownika oraz hasło są nieprawidłowe."
    }
  },
  app: {
    consel: "ConSEL",
    name: "Aplikacja Utrzymaniowa",
    shortName: "AU"
  },
  username: "Nazwa użytkownika",
  password: "Hasło",
  login: "Zaloguj",
  logout: "Wyloguj",
  name: "Nazwa",
  actions: "Akcje",
  users: "Użytkownicy",
  user: "Użytkownik",
  editUser: "Edytuj użytkownika",
  createUser: "Utwórz użytkownika",
  delete: "Usuń",
  passwordRepeat: "Powtórz hasło",
  close: "Zamknij",
  save: "Zapisz",
  savedSuccessfully: "{0} zapisany pomyślnie",
  deletedSuccessfully: "{0} usunięty pomyślnie",
  changePassword: "Zmiana hasła",
  fulltextSearch: "Wyszukiwarka",
  confirmation: {
    deleteTitle: "Potwierdzenie usunięcia",
    deleteUserMessage: 'Czy na pewno chcesz usunąć użytkownika "{0}"?',
    deleteVehicleMessage: 'Czy na pewno chcesz usunąć pojazd "{0}"?',
    deleteFaultMessage: 'Czy na pewno chcesz usunąć komunikat błędu "{0}"?',
    deleteIssueMessage: 'Czy na pewno chcesz usunąć userkę "{0}"?',
    deleteServiceReport: 'Czy na pewno chcesz usunąć raport serwisowy "{0}"?',
    deleteSparePart: 'Czy na pewno chcesz usunąć część zamienną "{0}"?',
    deletefleet: 'Czy na pewno chcesz usunąć tę flotę?'
  },
  no: "Nie",
  yes: "Tak",
  permissionsRole: {
    ROLE_SUPER_ADMIN: "Administrator",
    ROLE_PERMISSION_USER_MANAGEMENT: "Zarządzanie użytkownikami",
    ROLE_PERMISSION_VEHICLE_VIEW_DETAILS: "Widok detali pojazdów",
    ROLE_PERMISSION_VEHICLE_MANAGEMENT: "Zarządzanie pojazdami",
    ROLE_PERMISSION_VEHICLE_DATA_FEED:
      "Systemowa aktualizacja danych o pojazdach",
    ROLE_PERMISSION_DICTIONARIES_MANAGEMENT: "Zarządzanie danymi słownikowymi",
    ROLE_PERMISSION_ISSUE_CREATE: "Zgłaszanie usterek",
    ROLE_PERMISSION_ISSUE_CHANGE_STATUS: "Zmiana statusu usterki",
    ROLE_PERMISSION_ISSUE_AUTOMATIC: "Usterki tworzone automatycznie",
    ROLE_PERMISSION_SERVICE_REPORT_CREATE: "Tworzenie raportu serwisowego",
    ROLE_PERMISSION_SERVICE_REPORT_EDIT: "Edycja raportu serwisowego",
    ROLE_PERMISSION_SERVICE_REPORT_DELETE: "Usuwanie raportu serwisowego",
    ROLE_PERMISSION_ISSUE_FINNISH: "Zamykanie usterki",
    ROLE_PERMISSION_REVIEW_REPORT_CREATE: "Tworzenie raportu przeglądowego",
    ROLE_PERMISSION_REVIEW_REPORT_EDIT: "Edycja raportu przeglądowego",
    ROLE_PERMISSION_REVIEW_REPORT_DELETE: "Usuwanie raportu przeglądowego",
    ROLE_PERMISSION_COMPREHENSIVE_REPORT_GENERATE:
      "Dostęp do raportu całościowego",
    ROLE_PERMISSION_ISSUE_FETCH_STATUS_HISTORY:
      "Widok historii statusów usterki",
    ROLE_PERMISSION_SPARE_PART_MANAGEMENT: "Zarządzanie częsciami zamiennymi",
    ROLE_PERMISSION_SPARE_PART_VIEW: "Przeglądanie części zamiennych"
  },
  permissions: "Uprawnienia",
  vehicles: "Pojazdy",
  vehicle: "Pojazd",
  lastSeen: "Ostatnio widziany",
  lastUpdated: "Ostatnio zaaktualizowano",
  creationDate: "Data utworzenia",
  odometer: "Licznik kilometerów",
  never: "Nigdy",
  createVehicle: "Dodaj pojazd",
  editVehicle: "Edytuj pojazd",
  consel_id: "ConSEL ID",
  fleet: "Typ floty ",
  fleet0: "Brak rozróżnienia",
  fleetIdAlreadyExists: "Numer floty jest już zajęty",
  idRequired: "Ten numer floty jest już w użyciu",
  idExists: "Ten numer floty jest już w użyciu",
  fleets: "Floty",
  unknownFleet: "Flota usunięta",
  selectFleet: "Wybierz flotę",
  editfleet: "Edytuj flotę",
  createfleet: "Dodaj flotę",
  faultsPriority0: "Kom. pr. 0",
  faultsPriority1: "Kom. pr. 1",
  faultsPriority2: "Kom. pr. 2",
  faultsPriority3: "Kom. pr. 3",
  faultsPriority0FullText: "Komunikaty o priorytecie 0",
  faultsPriority1FullText: "Komunikaty o priorytecie 1",
  faultsPriority2FullText: "Komunikaty o priorytecie 2",
  faultsPriority3FullText: "Komunikaty o priorytecie 3",
  status: "Status",
  autoRefresh: {
    text: "Automatycznie odżwieżanie",
    period10seconds: "co 10 sekund",
    period30seconds: "co 30 sekund",
    period1minute: "co 1 minutę",
    period5minutes: "co 5 minut"
  },
  dashboard: {
    name: "Panel kontrolny",
    vehicles: "Obsługiwnych pojazdów",
    activeIssues: "Aktywnych usterek",
    newIssues: "Usterek niepotwierdzonych",
    overcomeDistance: "Pokonany dystans",
    issuesStatus: "Statusy usterek",
    coefficientReliability: "Niezawodność",
      },
  mainMenu: "Menu główne",
  faultMessages: "Komunikaty błędów",
  priority: "Priorytet",
  createFaultMessage: "Utwórz komunikat błędu",
  editFaultMessage: "Edytuj komunikat błędu",
  issues: "Usterki",
  issue: "Usterka",
  number: "Numer",
  dsu: "DSU",
  issueItem: "Dotyczy elementu",
  occurrenceDate: "Data wystąpienia",
  occurrencePlaces: {
    PARKING_STATION: "Stacja postojowa/Hala",
    TRACK: "Trasa",
    INSPECTION: "Przegląd",
    EMERGENCY_TAKE_TO_BASE: "Zjazd awaryjny",
    OTHER: "Inne"
  },
  occurrencePlaceCustom: "Miejsce",
  createIssue: "Zgłoś usterkę",
  editIssue: "Zmodyfikuj usterkę",
  occurrencePlace: "Miejsce wystąpenia",
  issueItemAdditionalInfo: "Dodatkowe informacje",
  contactPerson: "Kontakt do osoby zgłaszającej usterkę",
  issueStatus: {
    NEW: "Wprowadzona",
    IN_VERIFICATION: "W trakcie weryfikacji",
    CONFIRMED: "Potwierdzona",
    IN_PROGRESS: "W trakcie realizacji",
    UNCONFIRMED: "Niepotwierdzona",
    RESOLVED: "Usunięta"
  },
  updateStatus: "Zmień status",
  statusUpdatedSuccessfully: "Status zaktualizowany pomyślnie",
  cancel: "Anuluj",
  all: "Wszystkie",
  new: "Nowe",
  active: "Aktywne",
  resolved: "Zakończone",
  lack: "Brak",
  creator: "Twórca",
  show: "Pokaż",
  statusesHistory: "Historia statusów",
  serviceReports: "Raporty serwisowe",
  serviceReport: "Raport serwisowy",
  components: "Komponenty",
  component: "Komponent",
  productGroups: "Grupa produktowa",
  issueCode: "Kod usterki",
  repairCode: "Kod naprawy",
  reason: "Przyczyna",
  vehiclePart: "Nr wagonu (członu)",
  issueCategory: "Kategoria uszkodzenia",
  repairCategory: "Kategoria naprawy",
  issueDescription: "Opis usterki",
  createServiceReport: "Utwórz raport serwisowy",
  editServiceReport: "Zmodyfikuj raport serwisowy",
  vehicleExcludedFrom: "Data wyłączenia pojazdu/przekazania gwarantowi",
  vehicleExcludedUntil: "Data dopuszczenia pojazdu/przekazania klientowi",
  additionalRepairOutsideVehicle:
    "Naprawa była wykonana dodatkowo poza pojazdem",
  serviceReportDisplayedMessage: "Wyświetlany komunikat usterki",
  issueCategories: {
    VEHICLE_OUT_OF_ORDER: "Usterka systemu unieruchamiająca pojazd",
    VEHICLE_CANT_WORK: "Usterka systemu uniemożliwająca funkcjonowanie pojazdu",
    VEHICLE_LIMITED_WORK:
      "Usterka systemu ograniczająca funkcjonowanie pojazdu",
    VEHICLE_FULLY_FUNCTIONAL: "Usterka nie wpływa na funkcjonowanie pojazdu"
  },
  additionalInformation: "Dodatkowe informacje, dotyczące wykonanych działań",
  hasAffectPassengerSafety: "Usterka mogła wpłynąć na bezpieczeństwo pasażerów",
  repairCategories: {
    IN_STATIONING_PLACE: "W miejscu funkcjonowania pojazdu",
    OUTSIDE_STATIONING_PLACE: "Poza miejscem funkcjoniwania pojazdu"
  },
  hasDiagnosticReport: "Zarchiwizowano zapis diagnostyczny urządzenia",
  diagnosticReportInfo: "Gdzie przesłano",
  vehicleExcluded: "Pojazd wyłączony z eksploatacji",
  faultyPart: "Zdemontowana (wadliwa) część",
  repairedPart: "Zainstalowana (nowa lub po naprawie) część",
  worklog: {
    name: "Czas pracy",
    workStart: "Data i godz. rozpoczęcia pracy",
    workFinish: "Data i godz. zakończenia pracy",
    findingIssue: "Znalezienie usterki [min]",
    repair: "Naprawa/Wymiana (MTTR) [min]",
    testing: "Testowanie [min]",
    employeesNumber: "Ilość pracowników",
    accessToParkingPlace:
      "Dojazd do miejsca postoju obiektu (jeśli poza STP) [min]",
    administration: "Administracja [min]",
    ownWork: "Praca własna",
    continuationOfWork: "Kontynuacja pracy",
    continuationOfWork2: "Kontynuacja pracy",
    userWork: "Praca użytkownika",
    supplierWork: "Praca dostawcy"
  },
  reviewReportWorklog: {
    name: "Czas pracy",
    workStart: "Pojazd przekazany do pracy serwisu",
    workFinish: "Pojazd przyjęty do pracy serwisu",
    madeReviewP1: "Zakończenie przeglądu",
    vehicleTakenByOccupant: "Pojazd przyjęty przez użytkownika"
  },
  projectPhase: "Faza projektu",
  projectPhases: {
    WARRANTY: "Gwarancja",
    PAID_REPAIR: "Naprawa płatna",
    SUPPORT: "Utrzymanie"
  },
  issueAppearMethod: "Nr reklamacji użytkownika/Sposób przekazu zgłoszenia",
  issueAppearMethods: {
    SERVICE_ACTION: "Akcja serwisowa",
    POST_WARRANTY_REPAIR: "Naprawa pogwarancyjna",
    INSPECTION: "Oględziny",
    DURING_INSPECTION_P1: "Podczas przeglądu P1",
    DURING_INSPECTION_P2: "Podczas przeglądu P2",
    DURING_INSPECTION_P3: "Podczas przeglądu P3",
    COMPLAINT: "Reklamacja",
    SERVICE: "Serwis",
    CUSTOM_NUMBER: "Wpisz numer",
    ENTRY_IN_VEHICLE_BOOK: "Wpis w książce pojazdu",
    TELEPHONE_ISSUE: "Zgłoszenie telefoniczne",
    CONSTRUCTION_CHANGE: "Zmiana konstrukcyjna"
  },
  customIssueAppearMethodNumber: "Numer zgłoszenia",
  continue: "Dalej",
  dictionaries: "Dane słownikowe",
  partWasReplaced: "Została wymieniona część",
  finnishIssue: "Zamknij usterkę",
  reviewReports: "Raporty przeglądowe",
  reviewReport: "Raport przeglądowy",
  createReviewReport: "Utwórz raport przeglądowy",
  editReviewReport: "Zmodyfikuj raport przeglądowy",
  reviewDate: "Data wykonania przeglądu",
  reviewReportBased: "Przegląd wykonany na podstawie DSU/rewizja/data wydania",
  reviewPlace: "Miejsce wykonania przeglądu",
  reviewPlaces: {
    PARKING_STATION: "Stacja postojowa/Hala",
    HOLDING_TRACKS: "Tory odstawcze",
    OTHER: "Inne"
  },
  reviewType: "Rodzaj przeglądu",
  reviewReportSubcontractor: "Przegląd wykonany przez poddostawcę",
  reviewReportSubcontractorDeviceName:
    "Nazwa urządzenia na którym wykonany jest przegląd przez jednostkę zewnętrzną",
  warrantyRepairs:
    "Podczas przeglądu wykonano naprawy gwarancyjne z których powstał Raport Serwisowy",
  consumables: "Materiały eksploatacyjne",
  usedConsumables: "Zużyte materiały eksploatacyjne (podać ilości)",
  details: "Szczegóły",
  edit: "Edytuj",
  showIssueStatusHistory: "Pokaż historię statusów usterki",
  bitWord: "Słowo bitowe",
  bit: "Bit",
  generatedAutomatically: "Wygenerowana automatycznie",
  download: "Pobierz",
  generate: "Generuj",
  dateFrom: "Data od",
  dateUntil: "Data do",
  dataFrom: "Dane od",
  dataUntil: "Dane do",
  distance: "Dystans",
  issuesCount: "Ilość usterek",
  criticalIssuesCount: "Ilość usterek krytycznych",
  vehicleReadiness: "Gotowość",
  numberOfOccurrences: "Liczba wystąpień",
  duration: "Czas trwania",
  automaticIssuesCount: "Ilość usterek wygenerowanych automatycznie",
  vehicleInaccessibility: "Łączny czas wyłączenia pojazdu",
  day: "dzień",
  days: "dni",
  hour: "godzinę",
  hours: "godzin",
  minutes: "minut",
  reports: "Raporty",
  basicReport: "Raport zbiorczy",
  detailedReport: "Raport szczegółowy",
  issuesReport: "Raport usterek",
  from: "od",
  until: "do",
  repair: "Naprawa",
  assignedIssue: "Przypisana usterka",
  comprehensiveReport: "Raport całościowy",
  occurrencePlaceCustomComplaintNumber: "Numer karty przekazania pojazdu",
  vehicleStatus: {
    WORKING: "Sprawny",
    EXCLUDED_FROM_TRAFFIC: "Wyłączony z ruchu",
    WITH_REPORTED_FAILURE: "Ze zgłoszoną usterką"
  },
  enabled: "Aktywny",
  disabled: "Nieaktywny",
  enabledUntil: "Aktywny do dnia",
  email: "Adres e-mail",
  sendNewIssueReminderAfter: "Wyślij e-mail z przypomnieniem o nowej usterce",
  selectAllVehicles: "Wybierz wszystkie pojazdy",
  reviewDuration: "Czas trwania",
  ok: "Ok",
  date: "Data",
  time: "Czas",
  coefficientReadinessReport: "Współczynnik gotowości pojazdów",
  refreshCoefficient: "Odśwież współczynnik",
  yearly: "Roczny",
  monthly: "Miesięczny",
  inaccessibilityInMinutes: "Niedostępność w minutach",
  inaccessibilityInHours: "Niedostępność w godzinach",
  year: "rok",
  month: "miesiąc",
  refreshCoefficientReadinessSuccessfully:
    "Współczynnik gotowości został odświeżony pomyślnie",
  refreshCoefficientReadinessTooltip:
    "Ponowne wyliczenie współczynnika gotowości pojazdów dla bieżącego roku i miesiąca",
  files: "Pliki",
  createComponent: "Dodaj komponent",
  editComponent: "Edytuj komponent",
  quarter: "Kwartał",
  vehicleReliability: "Współczynnik niezawodności",
  refreshCoefficientReliabilityTooltip:
    "Ponowne wyliczenie współczynnika niezawodności pojazdów dla bieżącego kwartału",
  refreshCoefficientReliabilitySuccessfully:
    "Współczynnik niezawodności został odświeżony pomyślnie",
  coefficientReliabilityReport: "Współczynnik niezawodności pojazdów",
  menu: {
    coefficientReadinessReport: "Gotowość",
    coefficientReliabilityReport: "Niezawodność",
    basicReport: "Zbiorczy",
    detailedReport: "Szczegółowy",
    issuesReport: "Usterek",
    comprehensiveReport: "Całościowy",
    coefficients: "Współczynniki",
    sparePartReport: "Części zamiennych"
  },
  serialNumber: "Numer seryjny",
  typeOrSelectSerialNumber: "Wpisz lub wybierz numer seryjny",
  sparePartTypes: "Typy części zamiennych",
  spareParts: "Części zamienne",
  sparePart: "Część zamienna",
  sparePartType: "Typ części zamiennej",
  unreadableSerialNumber:
    "Brak możliwości poprawnego odczytania numeru seryjnego",
  createSparePartType: "Utwórz typ części zamiennej",
  createSparePart: "Wprowadź nową część",
  editSparePart: "Edycja części zamiennej",
  showSparePart: "Widok części zamiennej",
  type: "Typ",
  installedAt: "Data i godzina instalacji",
  installedBy: "Zainstalowana przez",
  replacedAt: "Data i godzina wymiany",
  replacedBy: "Osoba która dokonała wymiany",
  sparePartReplacedOn: "Numer seryjny na jaki wymieniono",
  replacedSparePart: "Numer seryjny i typ wymienionej części",
  sparePartsForVehicle: "Części zamienne dla pojazdu",
  showSparePartHistory: "Historia wymian",
  showSparePartsHistoryTooltip: "Pokaż historię wymian",
  sparePartStatus: {
    REPLACED: "Wymieniona",
    INSTALLED: "W użyciu"
  },
  includeReplacedSpareParts: "Uwzględnij wymienione części",
  sparePartReport: "Raport części zamiennych",
  createUserTooltip: "Utwórz użytkownika",
  createVehicleTooltip: "Dodaj pojazd",
  createIssueTooltip: "Dodaj usterkę",
  createServiceReportTooltip: "Utwórz raport serwisowy",
  createReviewReportTooltip: "Utwórz raport przeglądowy",
  vehicleStartedServiceAt: "Data oddania pojazdu do użytku"
};
